/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".edit-mobile-dropdown[_ngcontent-%COMP%]{height:calc(1.4em + 2px + .75rem)!important;background-color:#fff;border-left-style:solid!important;border-left-width:2px!important;margin:auto!important;border-right:0!important;border-top-left-radius:50rem!important;border-bottom-left-radius:50rem!important}  .changedropdown .ui-dropdown{min-width:106px!important}"];
export { styles as styles };

